import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

/**
 * ConfirmDialog. Props: { open, title, message, onCancel, onConfirm, confirmLabel }
 */
const ConfirmDialog = ({ open, title = 'Are you sure?', message, onCancel, onConfirm, confirmLabel = 'Delete' }) => {
  const [working, setWorking] = useState(false);
  if (!open) return null;
  const handleConfirm = async () => {
    setWorking(true);
    try { await onConfirm(); } finally { setWorking(false); }
  };
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onCancel} />
      <div className="relative bg-white border border-[#e9e0cc] w-full max-w-md p-6">
        <button onClick={onCancel} className="absolute top-3 right-3 text-[#5a534a] hover:text-[#3a2359]"><X size={18} /></button>
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-[#fdecec] text-[#a63a3a] flex items-center justify-center flex-shrink-0">
            <AlertTriangle size={18} />
          </div>
          <div>
            <h3 className="font-display text-xl text-[#2a1a45]">{title}</h3>
            {message && <p className="text-sm text-[#5a534a] mt-1">{message}</p>}
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 pt-3 border-t border-[#e9e0cc]">
          <button onClick={onCancel} className="px-4 py-2 border border-[#e9e0cc] text-sm text-[#5a534a] hover:bg-[#faf7f0]">Cancel</button>
          <button onClick={handleConfirm} disabled={working} className="px-5 py-2 bg-[#a63a3a] text-white text-sm hover:bg-[#8a2f2f] disabled:opacity-60">
            {working ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
